(function(window){
  // Minimal scoped header nav helper moved to its own asset
  window.theme = window.theme || {};

  var registry = new WeakMap();

  function _setMaxHeightNone(menu){
    var handler = function(e){
      if(e.propertyName === 'max-height'){
        menu.style.maxHeight = 'none';
        menu.removeEventListener('transitionend', handler);
      }
    };
    menu.addEventListener('transitionend', handler);
  }

  function init(container){
    if(!container) return;
    if(registry.has(container)) return; // already initialized

  var btn = container.querySelector('.nav__menu');
  var menu = container.querySelector('.nav-menu');
  if(!btn || !menu) return;

    var handlers = {};

    handlers.open = function(){
      // start open animation by measuring and applying explicit height
      menu.classList.add('nav-menu--open');
      var height = menu.scrollHeight;
      // ensure any previous explicit maxHeight is cleared before measuring
      menu.style.maxHeight = height + 'px';

      // Use double RAF to ensure the transition kicks in reliably
      window.requestAnimationFrame(function(){
        window.requestAnimationFrame(function(){
          // once the open transition finishes, remove explicit maxHeight so content can resize
          var onOpenEnd = function(e){
            if(e.propertyName === 'max-height'){
              menu.style.maxHeight = 'none';
              menu.removeEventListener('transitionend', onOpenEnd);
            }
          };
          menu.addEventListener('transitionend', onOpenEnd);
        });
      });

      btn.setAttribute('aria-expanded','true');
      btn.classList.add('is-active');
      // menu button gets .is-active (handled below) — menu icons toggle via CSS
    };

    handlers.close = function(){
      // to animate close reliably: set explicit height, then collapse to 0 in next frame
      var height = menu.scrollHeight;
      menu.style.maxHeight = height + 'px';

      // Use RAF to ensure browser registers the starting height before transitioning to 0
      window.requestAnimationFrame(function(){
        window.requestAnimationFrame(function(){
          menu.style.maxHeight = '0';
        });
      });

      var onClose = function(e){
        if(e.propertyName === 'max-height'){
          menu.classList.remove('nav-menu--open');
          // clear any lingering explicit height to avoid layout issues
          menu.style.maxHeight = '';
          menu.removeEventListener('transitionend', onClose);
        }
      };
      menu.addEventListener('transitionend', onClose);

      btn.setAttribute('aria-expanded','false');
      btn.classList.remove('is-active');
      // menu button gets .is-active removed — menu icons toggle via CSS
    };

    handlers.toggle = function(evt){
      evt && evt.stopPropagation();
      if(menu.classList.contains('nav-menu--open')){
        handlers.close();
      } else {
        handlers.open();
      }
    };

    handlers.outsideClick = function(e){
      if(!menu.contains(e.target) && !btn.contains(e.target) && menu.classList.contains('nav-menu--open')){
        handlers.close();
      }
    };

    handlers.keydown = function(e){
      if(e.key === 'Escape' || e.key === 'Esc'){
        if(menu.classList.contains('nav-menu--open')) handlers.close();
      }
    };

    btn.addEventListener('click', handlers.toggle);
    document.addEventListener('click', handlers.outsideClick);
    document.addEventListener('keydown', handlers.keydown);

    registry.set(container, handlers);
  }

  function destroy(container){
    if(!container) return;
    var handlers = registry.get(container);
    if(!handlers) return;

    var btn = container.querySelector('.nav__menu');
    var menu = container.querySelector('.nav-menu');
    if(btn && handlers.toggle) btn.removeEventListener('click', handlers.toggle);
    document.removeEventListener('click', handlers.outsideClick);
    document.removeEventListener('keydown', handlers.keydown);

    // clear styles/classes
    if(menu){
      menu.style.maxHeight = '';
      menu.classList.remove('nav-menu--open');
    }
    if(btn){
      btn.classList.remove('is-active');
      btn.setAttribute('aria-expanded','false');
    }
  // nothing to cleanup for cart icons here

    registry.delete(container);
  }

  // attach to a reserved name to avoid clashing with theme.headerNav
  theme.handleNavigation = {
    init: init,
    destroy: destroy
  };

  function initAll(){
    document.querySelectorAll('[data-header-nav]').forEach(function(el){
      theme.handleNavigation.init(el);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    var container = e.target && e.target.querySelector ? e.target.querySelector('[data-header-nav]') : null;
    if(container) theme.handleNavigation.init(container);
  });

  document.addEventListener('shopify:section:unload', function(e){
    var container = e.target && e.target.querySelector ? e.target.querySelector('[data-header-nav]') : null;
    if(container) theme.handleNavigation.destroy(container);
  });

})(window);
